/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Send_Reset_LinkInputs */



/**
* | output |
* | --- |
* | "Send Reset Link" |
*
* @param {Login_Send_Reset_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_send_reset_link = /** @type {((inputs?: Login_Send_Reset_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Send_Reset_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar enlace de recuperación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar Link de Redefinição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia Link di Reimpostazione")
	return /** @type {LocalizedString} */ ("Send Reset Link")
});